import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function LockPaymentCard1({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>LockPaymentCard1</title>
      <path
        d="M21 10.5V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V17C3 18.1046 3.89543 19 5 19H12"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2857 15.5714V16.3214C19.6999 16.3214 20.0357 15.9856 20.0357 15.5714H19.2857ZM16.7143 15.5714H15.9643C15.9643 15.9856 16.3001 16.3214 16.7143 16.3214V15.5714ZM15.8571 16.3214H20.1429V14.8214H15.8571V16.3214ZM20.25 16.4286V19.1429H21.75V16.4286H20.25ZM20.1429 19.25H15.8571V20.75H20.1429V19.25ZM15.75 19.1429V16.4286H14.25V19.1429H15.75ZM15.8571 19.25C15.798 19.25 15.75 19.202 15.75 19.1429H14.25C14.25 20.0305 14.9695 20.75 15.8571 20.75V19.25ZM20.25 19.1429C20.25 19.202 20.202 19.25 20.1429 19.25V20.75C21.0305 20.75 21.75 20.0305 21.75 19.1429H20.25ZM20.1429 16.3214C20.202 16.3214 20.25 16.3694 20.25 16.4286H21.75C21.75 15.541 21.0305 14.8214 20.1429 14.8214V16.3214ZM15.8571 14.8214C14.9695 14.8214 14.25 15.541 14.25 16.4286H15.75C15.75 16.3694 15.798 16.3214 15.8571 16.3214V14.8214ZM18.5357 14.2857V15.5714H20.0357V14.2857H18.5357ZM19.2857 14.8214H16.7143V16.3214H19.2857V14.8214ZM17.4643 15.5714V14.2857H15.9643V15.5714H17.4643ZM18 13.75C18.2959 13.75 18.5357 13.9898 18.5357 14.2857H20.0357C20.0357 13.1614 19.1243 12.25 18 12.25V13.75ZM18 12.25C16.8757 12.25 15.9643 13.1614 15.9643 14.2857H17.4643C17.4643 13.9898 17.7041 13.75 18 13.75V12.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M3 10H20.5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 15H9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
